
import { useState } from 'react';

import moment from 'moment';
import Util from 'service/util';
import { SYS } from 'service/api';

import PopMessage from 'component/pop-msg/PopMessage';

const SYSChangeBalanceModal = ({owner, ...props}) =>
{
  const [balance, setBalance] = useState(owner.balance || 0);
  const [_bth, toggleButton]  = useState(false); // disable button

  const changeBalance = () =>
  {
    toggleButton(true);

    let dto = { id: owner.id, balance };

    SYS.editBalance(dto).then(resp => {
      if (resp.success)
      {
        PopMessage.show(resp.msg, '成功', 'success');
        props.onUpdated();
        props.closeModal();
      } else {
        PopMessage.show(resp.msg, '連接失敗', 'danger');
      }
      toggleButton(false);
    });
  }

  return (
    <>
      <p className="message red">*注意* 操作將無法復原。</p>
      <label className="field">
        <strong>賬戶餘額</strong>
        <input type="number" value={balance} onChange={e=>setBalance(parseInt(e.target.value || 0, 10))} />
      </label>
      <div className="action-panel">
        <span className="dummy"></span>
        <button className="btn red" type="button"
          onClick={changeBalance}
          disabled={_bth}
        >確定
        </button>
      </div>
    </>
  );
}



export default SYSChangeBalanceModal;